import { cn } from '@/lib/utils'

type PageShellProps = Readonly<{
  children: React.ReactNode
  className?: string
}>

export function PageShell({ children, className }: PageShellProps) {
  return (
    <div className={cn('mx-auto w-full max-w-[var(--container-page)] px-4 py-8 sm:px-6 lg:px-8 lg:py-12', className)}>
      {children}
    </div>
  )
}

export function MarketingPageShell({ children, className }: PageShellProps) {
  return (
    <PageShell className={cn('pb-14 pt-10 sm:pb-16 sm:pt-12 lg:pb-20 lg:pt-16', className)}>
      <div className="grid gap-10 lg:gap-12">{children}</div>
    </PageShell>
  )
}

export function ContentPageShell({ children, className }: PageShellProps) {
  return (
    <PageShell className={cn('py-10 sm:py-12 lg:py-16', className)}>
      <div className="mx-auto w-full max-w-[var(--container-content)]">{children}</div>
    </PageShell>
  )
}
